import React from "react";
import { POST } from "../services/api";
import Sidebar from "./membermenu";

const MemberLayout = ({ children }) => {

  const handleLogout = async () => {
    try { 
      await POST("/auth/member-logout", {});
    } catch (error) {
      console.error("Logout API error:", error);
    } finally { 
      localStorage.removeItem("authToken");
      localStorage.removeItem("user");
      localStorage.clear();

      window.location.href = "/member-login";
    }       
  };

  return (
    <div className="member-layout">
      <Sidebar handleLogout={handleLogout} />
      <main>
        {children}
      </main>
    </div>
  );
};

export default MemberLayout;